import { useState } from 'react';
import MessageMenuOverlay from './MessageMenuOverlay';

function MessageMenu({ message, chatId }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="absolute top-1 right-1 flex flex-col items-center justify-center gap-0.5 w-4 h-4 bg-gray-200/50 border border-white rounded-sm opacity-50 hover:opacity-80 transition-opacity cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
      >
        <div className="w-0.5 h-0.5 bg-white rounded-full"></div>
        <div className="w-0.5 h-0.5 bg-white rounded-full"></div>
        <div className="w-0.5 h-0.5 bg-white rounded-full"></div>
      </div>
      {isOpen && (
        <MessageMenuOverlay
          message={message}
          chatId={chatId}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}

export default MessageMenu;
